<header>
  <div class="logo-container">
    <a [routerLink]="HOME_LINK">
      <img class="logo" src="assets/img/header_icon.svg" alt="Coca-Cola Logo" />
    </a>
  </div>
  <div class="search-bar">
    <input
      type="search"
      placeholder="Search..."
      [(ngModel)]="searchString"
      (keydown.enter)="onSearch()"
    />
  </div>
  <nav class="navbar-links">
    <div class="navbar-link">
      <img class="icon" src="assets/img/icon_search.svg" (click)="onSearch()" />
    </div>
  </nav>
  <nav class="navbar-links">
    <div class="spacer"></div>
  </nav>
  <nav class="navbar-links">
    <div class="dropdown">
      <a [routerLink]="HOME_LINK" class="navbar-link">
        <img class="icon home-icon" src="assets/img/icon_home_solid.svg" />
      </a>
      <div class="dropdown-content">
        <ng-container>
          <span class="dropdown-header">Device Management</span>
          <a class="dropdown-item" routerLink="/manage/dashboard">Dashboard</a>
          <a class="dropdown-item" routerLink="/manage/devices">Devices</a>
          <a class="dropdown-item" routerLink="/manage/device-groups">Device Groups</a>
          <a class="dropdown-item" routerLink="/manage/artifacts">Artifacts</a>
        </ng-container>
      </div>
    </div>
  </nav>
  <nav class="navbar-links">
    <div class="dropdown">
      <div class="navbar-link">
        <img class="icon" src="assets/img/icon_settings.svg" />
      </div>
      <div class="dropdown-content">
        @if (admin) {
          <span class="dropdown-header">Settings</span>
          <a class="dropdown-item" routerLink="/administration/users">Manage Users</a>
          <a class="dropdown-item" routerLink="/administration/groups">Manage Groups</a>
          <a class="dropdown-item" routerLink="/administration/sysconfig">System Configuration</a>
        }
        <span class="dropdown-header">About</span>
        <a class="dropdown-item" (click)="getAbout()">Version Information</a>
      </div>
    </div>
  </nav>
  <nav class="navbar-links">
    <div class="dropdown">
      <div class="navbar-link">
        <img class="icon" src="assets/img/icon_profile.svg" />
        @if (userInfo) {
          <span class="dropdown-text">
            {{ userInfo.username || userInfo.preferred_username || userInfo.email }}
          </span>
        }
        <img class="small-icon" src="assets/img/icon_account_dropdown.svg" />
      </div>
      <div class="dropdown-content">
        <span class="dropdown-header">Account</span>
        <a class="dropdown-item" (click)="changePassword()">Change Password</a>
        <a class="dropdown-item" routerLink="/user/profile">User Profile</a>
        <a class="dropdown-item" (click)="authService.logout()">Logout</a>
      </div>
    </div>
  </nav>
</header>
